import { SImageResizableVariables } from '@strana-artw/ui-kit';
import { defineComponent, onBeforeUnmount, onMounted, provide, useCssModule } from 'vue';
export default defineComponent({
  name: 'LayoutPrint',
  setup: function setup() {
    var $style = useCssModule();
    provide(SImageResizableVariables.S_IMAGE_RESIZABLE_AVAILABILITY_INJECTION_KEY, true);
    onMounted(function () {
      document.documentElement.classList.add($style.htmlRoot);
    });
    onBeforeUnmount(function () {
      document.documentElement.classList.remove($style.htmlRoot);
    });
    return {};
  }
});